import { getFieldLabelColumn } from '@modules/quantify/hooks/useExportQuantifyReportDataAsCSV/helpers/getFieldLabelColumn';
import { QuantifyQuery } from '@modules/quantify/store/types';
import {
  getCompareLabelPrefix,
  isAggregateFormula,
} from '@modules/quantify/utils';
import { CsvColumnType, EqlField } from 'generated/graphql';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface getCompareAnalysisColumnsParams {
  formulaID?: EQLFunctionName;
  compareQuery: QuantifyQuery['compareQuery'];
  groupBy: QuantifyQuery['groupByField'];
  measuredAsCriteria: EqlField | undefined;
  compareFieldNames: {
    fieldAName: string;
    fieldBName: string;
  };
  shouldRemoveFileUploadPrefix: boolean;
  isUnifiedFieldEnabled: boolean;
}

export function getCompareAnalysisColumns({
  formulaID,
  compareQuery,
  groupBy,
  measuredAsCriteria,
  compareFieldNames: { fieldAName, fieldBName },
  shouldRemoveFileUploadPrefix,
  isUnifiedFieldEnabled,
}: getCompareAnalysisColumnsParams) {
  if (!compareQuery) {
    return [];
  }

  const compareLabelPrefix = getCompareLabelPrefix({
    formulaID,
    measuredAsCriteria,
  });
  const shouldShowFloatingValue = formulaID !== EQLFunctionName.Count;

  return [
    ...(isAggregateFormula(formulaID)
      ? []
      : [
          getFieldLabelColumn({
            groupBy,
            shouldRemoveFileUploadPrefix,
            isUnifiedFieldEnabled,
          }),
        ]),
    {
      title: `${compareLabelPrefix} ${fieldAName}`,
      type: shouldShowFloatingValue
        ? CsvColumnType.Float
        : CsvColumnType.Integer,
    },
    {
      title: `${compareLabelPrefix} ${fieldBName}`,
      type: shouldShowFloatingValue
        ? CsvColumnType.Float
        : CsvColumnType.Integer,
    },
    {
      title: 'Difference',
      type: shouldShowFloatingValue
        ? CsvColumnType.Float
        : CsvColumnType.Integer,
    },
    {
      title: 'Absolute Difference',
      type: shouldShowFloatingValue
        ? CsvColumnType.Float
        : CsvColumnType.Integer,
    },
  ];
}
